'use client';

import { c as _c } from "react/compiler-runtime";
import type { NegotiationDetails } from '../../types/negociacaoDetailUiTypes';
import { Badge, Button, DropdownMenu, IconButton, Separator } from '@/shared/components/ui';
import * as SubframeCore from '@subframe/core';
import { FeatherActivity, FeatherChevronLeft, FeatherClock, FeatherEdit2, FeatherMoreVertical, FeatherPause, FeatherPlay, FeatherRotateCcw, FeatherUser, FeatherXCircle } from '@subframe/core';
import { NegociacaoTemperatureBadge } from './NegociacaoTemperature';
interface NegociacaoDetailHeaderProps {
  negotiation: NegotiationDetails;
  isReadOnly: boolean;
  hasPendingStart: boolean;
  isClosed?: boolean;
  onBackToList: () => void;
  onEditData: () => void;
  onCancelStart: () => void;
  onPauseCaso: () => void;
  onResumeCaso: () => void;
  onOpenEncerramentoModal: () => void;
  onOpenReaberturaModal: () => void;
  showTemperature?: boolean;
  getTemperatureColorClass: (temp: string) => string;
}
export function NegociacaoDetailHeader(t0) {
  const $ = _c(68);
  const {
    negotiation,
    isReadOnly,
    hasPendingStart,
    isClosed: t1,
    onBackToList,
    onEditData,
    onCancelStart,
    onPauseCaso,
    onResumeCaso,
    onOpenEncerramentoModal,
    onOpenReaberturaModal,
    showTemperature: t2,
    getTemperatureColorClass
  } = t0;
  const isClosed = t1 === undefined ? false : t1;
  const showTemperature = t2 === undefined ? true : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherChevronLeft className="h-4 w-4" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== onBackToList) {
    t4 = <button type="button" className="text-caption text-subtext-color flex w-fit items-center gap-1.5 py-1 font-medium transition-opacity hover:opacity-80" onClick={onBackToList}>{t3}Voltar para a lista</button>;
    $[1] = onBackToList;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== negotiation.negotiationName) {
    t5 = <h1 className="text-heading-2 font-heading-2 text-default-font min-w-0 break-words">{negotiation.negotiationName}</h1>;
    $[3] = negotiation.negotiationName;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== negotiation.status || $[6] !== negotiation.statusVariant) {
    t6 = <Badge variant={negotiation.statusVariant}>{negotiation.status}</Badge>;
    $[5] = negotiation.status;
    $[6] = negotiation.statusVariant;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-3 gap-y-2">{t5}{t6}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== getTemperatureColorClass || $[12] !== negotiation.temperature || $[13] !== showTemperature) {
    t8 = showTemperature && <NegociacaoTemperatureBadge temperature={negotiation.temperature} getTemperatureColorClass={getTemperatureColorClass} />;
    $[11] = getTemperatureColorClass;
    $[12] = negotiation.temperature;
    $[13] = showTemperature;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isClosed || $[16] !== onOpenReaberturaModal) {
    t9 = isClosed && <Button variant="brand-secondary" icon={<FeatherRotateCcw />} size="small" onClick={onOpenReaberturaModal}>Reabrir</Button>;
    $[15] = isClosed;
    $[16] = onOpenReaberturaModal;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isReadOnly || $[19] !== negotiation.isPaused || $[20] !== negotiation.isScheduled || $[21] !== onPauseCaso || $[22] !== onResumeCaso) {
    t10 = !isReadOnly && !negotiation.isScheduled && <>{negotiation.isPaused ? <Button variant="neutral-secondary" icon={<FeatherPlay />} size="small" onClick={onResumeCaso}>Retomar</Button> : <Button variant="neutral-secondary" icon={<FeatherPause />} size="small" onClick={onPauseCaso}>Pausar</Button>}</>;
    $[18] = isReadOnly;
    $[19] = negotiation.isPaused;
    $[20] = negotiation.isScheduled;
    $[21] = onPauseCaso;
    $[22] = onResumeCaso;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SubframeCore.DropdownMenu.Trigger asChild={true}><IconButton variant="neutral-tertiary" icon={<FeatherMoreVertical />} size="small" /></SubframeCore.DropdownMenu.Trigger>;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== isReadOnly || $[26] !== onEditData) {
    t12 = !isReadOnly ? <DropdownMenu.DropdownItem icon={<FeatherEdit2 />} onClick={onEditData}>Editar dados</DropdownMenu.DropdownItem> : null;
    $[25] = isReadOnly;
    $[26] = onEditData;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== hasPendingStart || $[29] !== onCancelStart) {
    t13 = hasPendingStart ? <><Separator /><DropdownMenu.DropdownItem icon={<FeatherClock />} onClick={onCancelStart}>Cancelar início</DropdownMenu.DropdownItem></> : null;
    $[28] = hasPendingStart;
    $[29] = onCancelStart;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== isReadOnly || $[32] !== onOpenEncerramentoModal) {
    t14 = !isReadOnly ? <><Separator /><DropdownMenu.DropdownItem icon={<FeatherXCircle />} className="text-error-600" onClick={onOpenEncerramentoModal}>Encerrar negociação</DropdownMenu.DropdownItem></> : null;
    $[31] = isReadOnly;
    $[32] = onOpenEncerramentoModal;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t14) {
    t15 = <SubframeCore.DropdownMenu.Root>{t11}<SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content align="end" className="animate-fade-in"><DropdownMenu>{t12}{t13}{t14}</DropdownMenu></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal></SubframeCore.DropdownMenu.Root>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t10 || $[39] !== t15 || $[40] !== t9) {
    t16 = <div className="flex flex-wrap items-center gap-2">{t9}{t10}{t15}</div>;
    $[38] = t10;
    $[39] = t15;
    $[40] = t9;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t16 || $[43] !== t8) {
    t17 = <div className="flex flex-wrap items-center gap-2 min-[1100px]:shrink-0">{t8}{t16}</div>;
    $[42] = t16;
    $[43] = t8;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t17 || $[46] !== t7) {
    t18 = <div className="flex w-full flex-col gap-4 min-[1100px]:flex-row min-[1100px]:items-start min-[1100px]:justify-between">{t7}{t17}</div>;
    $[45] = t17;
    $[46] = t7;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== negotiation.numeroNegociacao) {
    t19 = negotiation.numeroNegociacao && <span className="text-default-font font-medium">{negotiation.numeroNegociacao}</span>;
    $[48] = negotiation.numeroNegociacao;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <FeatherUser className="h-3.5 w-3.5 shrink-0" />;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== negotiation.client) {
    t21 = <span className="flex min-w-0 items-center gap-1.5">{t20}<span className="break-words">{negotiation.client}</span></span>;
    $[51] = negotiation.client;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <FeatherActivity className="h-3.5 w-3.5 shrink-0" />;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== negotiation.agent) {
    t23 = <span className="flex items-center gap-1.5">{t22}{negotiation.agent}</span>;
    $[54] = negotiation.agent;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <FeatherClock className="h-3.5 w-3.5 shrink-0" />;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== negotiation.updatedTime) {
    t25 = <span className="flex items-center gap-1.5">{t24}Atualizado em {negotiation.updatedTime}</span>;
    $[57] = negotiation.updatedTime;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t19 || $[60] !== t21 || $[61] !== t23 || $[62] !== t25) {
    t26 = <div className="text-caption text-subtext-color flex w-full flex-wrap items-center gap-x-5 gap-y-2">{t19}{t21}{t23}{t25}</div>;
    $[59] = t19;
    $[60] = t21;
    $[61] = t23;
    $[62] = t25;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t18 || $[65] !== t26 || $[66] !== t4) {
    t27 = <div className="flex w-full flex-col gap-3 border-b border-solid border-neutral-100 bg-white pb-4">{t4}{t18}{t26}</div>;
    $[64] = t18;
    $[65] = t26;
    $[66] = t4;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  return t27;
}